import React from "react";

const UpdateBook = () => {
  return <div>UpdateBook</div>;
};

export default UpdateBook;
